import React from 'react';

import PropTypes from 'prop-types';

const InformationAlertDescription = ({ children }) => (
  <div className="information-alert__content__description">{children}</div>
);

InformationAlertDescription.propTypes = {
  children: PropTypes.node
};

export default InformationAlertDescription;
